import { useRecoilTransaction_UNSTABLE } from "recoil"

import type { TransactionOperation } from "."
import { panelIndex, panelSelectionState } from "../panels"
import { areasOfPanelsIndexState } from "../relations"
import type { UnknownChangeForUnknownElement } from "../timeline"
import { divergeTimeline, generateElementChange } from "../timeline/transactions"

export const deletePanels: TransactionOperation<Set<string>> = (
  transactors,
  panelIdSet,
) => {
  const { get, set, reset } = transactors
  const changes: UnknownChangeForUnknownElement[] = []

  if (panelIdSet.size > 0) {
    set(panelIndex, (ids) =>
      ids.filter((id) => {
        if (!panelIdSet.has(id)) {
          return true
        }
        changes.push(
          generateElementChange(transactors, {
            action: {
              type: `DELETE`,
              family: `PANEL`,
              id,
            },
          }),
        )
      }),
    )
    const selection = get(panelSelectionState)
    selection.forEach((panelId) => {
      set(areasOfPanelsIndexState, (current) => {
        const areaId = current.from(panelId)
        if (areaId) {
          current.delete(undefined, panelId)
          changes.push(
            generateElementChange(transactors, {
              action: {
                type: `DETACH`,
                family: `AREA_PANEL`,
                id: areaId,
                relatedId: panelId,
              },
            }),
          )
        }

        return current
      })
    })
  }
  if (changes.length) divergeTimeline(transactors, changes)
  reset(panelSelectionState)
}

export const useDeletePanels = (
  ...deps: ReadonlyArray<unknown>
): ((panelIds: Iterable<string> | string) => void) =>
  useRecoilTransaction_UNSTABLE(
    (transactors) => (ids) =>
      deletePanels(transactors, new Set(typeof ids === `string` ? [ids] : ids)),
    deps,
  )
